import { T } from "@supersig/validate";
import { idValidator } from "../../swschema/misc";
const stateIdValidator = idValidator("state");
export const buildReferential = (valueType)=>{
    return T.object({
        type: T.literal("referential"),
        stateId: stateIdValidator
    });
};
